import {
  getBusinessUnits,
  getBusinessUnitsPaginationResult,
} from 'gcs-common/slices/administration/businessUnits/businessUnitsSelectors';
import { fetchBusinessUnits } from 'gcs-common/slices/administration/businessUnits/businessUnitsThunks';
import { getGlobalSearchInput } from 'gcs-common/slices/administration/globalSearch/globalSearchSelectors';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SORT_ORDER } from '../../../../constants/sortConstants';
import detailsIcon from '../../../../img/arrow.svg';
import PaginatedTable from '../../../PaginatedTable/PaginatedTable';

const columns = [
  {
    Header: 'Name',
    accessor: 'friendlyName',
  },
];

const BusinessUnitTable = ({ onBusinessUnitSelected, businessUnitsLoading }) => {
  const businessUnits = useSelector(getBusinessUnits);
  const businessUnitsPagination = useSelector(getBusinessUnitsPaginationResult);
  const globalSearchInput = useSelector(getGlobalSearchInput);

  const dispatch = useDispatch();

  const accessorToBeSorted = columns.find((element) => element.Header).accessor;
  const [sortedColumnId, setSortedColumnId] = useState(accessorToBeSorted);
  const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASCENDING);

  const loadBusinessUnits = useCallback(
    (pageIndex, pageSize, searchQuery) => {
      dispatch(
        fetchBusinessUnits({
          pageIndex,
          pageSize,
          searchQuery,
          sortOrder,
          sortedColumnId,
        }),
      );
    },
    [dispatch, sortOrder, sortedColumnId],
  );

  return (
    <PaginatedTable
      onRowSelected={onBusinessUnitSelected}
      data={businessUnits}
      columns={columns}
      onPaginationChanged={loadBusinessUnits}
      searchInput={globalSearchInput}
      pagination={businessUnitsPagination}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
      sortedColumnId={sortedColumnId}
      setSortedColumnId={setSortedColumnId}
      sortIsLoading={businessUnitsLoading}
      renderActions={() => <img alt="details-icon" src={detailsIcon} />}
    />
  );
};

BusinessUnitTable.propTypes = {
  onBusinessUnitSelected: PropTypes.func.isRequired,
  businessUnitsLoading: PropTypes.bool.isRequired,
};

export default BusinessUnitTable;
